// Development
// export const SOCETCONNURL = "https://roadsidadmin.herokuapp.com";
// export const NOTIFICATIO_IMAGE = "http://localhost:4000";
// export const DEVICE_TOKEN =
//   "cnL46aWcSLWanKVeOrVDd4:APA91bESD1xF8vJNwupfXK5mWSq291wgYMjYDwYI06ZWl-CPOQfyI_HQieVt2n6fU0XW526tsVuS-mwxyEHLFUvulSsWlDKSGe686ISIBFLi2jRSwxQA1J4PRnNT3-0_iBJ65FGqOxzp";
// export const APIURL = "https://roadsidadmin.herokuapp.com";
// export const NODE_ENV = "production";

// // Production
// export const SOCETCONNURL = "https://roadside.ittechxpert.com";
// export const NOTIFICATIO_IMAGE = "https://roadside.ittechxpert.com";
// export const DEVICE_TOKEN =
//   "cnL46aWcSLWanKVeOrVDd4:APA91bESD1xF8vJNwupfXK5mWSq291wgYMjYDwYI06ZWl-CPOQfyI_HQieVt2n6fU0XW526tsVuS-mwxyEHLFUvulSsWlDKSGe686ISIBFLi2jRSwxQA1J4PRnNT3-0_iBJ65FGqOxzp";
// export const APIURL = "https://roadside.ittechxpert.com";
// export const NODE_ENV = "production";

// Local
// export const SOCETCONNURL = "http://localhost:4000";
// export const NOTIFICATIO_IMAGE = "http://localhost:4000";
// export const DEVICE_TOKEN =
//   "cnL46aWcSLWanKVeOrVDd4:APA91bESD1xF8vJNwupfXK5mWSq291wgYMjYDwYI06ZWl-CPOQfyI_HQieVt2n6fU0XW526tsVuS-mwxyEHLFUvulSsWlDKSGe686ISIBFLi2jRSwxQA1J4PRnNT3-0_iBJ65FGqOxzp";
// export const APIURL = "http://localhost:4000";
// export const NODE_ENV = "local";

// Production Live
export const SOCETCONNURL = "https://api.roadsideresponseltd.com";
export const NOTIFICATIO_IMAGE = "https://api.roadsideresponseltd.com";
export const DEVICE_TOKEN =
  "cnL46aWcSLWanKVeOrVDd4:APA91bESD1xF8vJNwupfXK5mWSq291wgYMjYDwYI06ZWl-CPOQfyI_HQieVt2n6fU0XW526tsVuS-mwxyEHLFUvulSsWlDKSGe686ISIBFLi2jRSwxQA1J4PRnNT3-0_iBJ65FGqOxzp";
export const APIURL = "https://api.roadsideresponseltd.com";
// export const APIURL = "http://localhost:8000";
export const NODE_ENV = "production";
export const REACT_APP_STRIPE_PUBLISHABLE_KEY="pk_live_51UP34qHy0kh9tNQSdY5EBHKrV70gdtZ6diUkZksbdCZZ5bOg0uskxfD4cNOM0ACnXC7hTOrf375PXuEBsVVbtcex00zhdjIktB";
